const cart_variants = JSON.parse(document.querySelector('[data-cart-variants]').textContent).variants;
(() => {
  document.querySelectorAll('[data-update-qty]').forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      const id_el = e.target.closest('[data-item-key]');
      if (id_el) {
        let updates = {};
        updates[id_el.dataset.itemKey] = parseInt(id_el.querySelector('[data-qty-input]').value);
        fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            updates
          })
        })
        .then(response => {
          return response.json();
        })
        .then(response => {
          if (response.status == 422) {
            alert(response.message);
          } else {
            location.reload();
          }
        })
        .catch((error) => {
          alert(error);
        });
      }
    })
  })

  document.querySelectorAll('[data-delete-item]').forEach(btn => {
    btn.addEventListener('click', e => {
      if (confirm(btn.dataset.deleteItem)) {
        const id_el = e.target.closest('[data-item-key]');
        if (id_el) {
          let updates = {};
          updates[id_el.dataset.itemKey] = 0;
          fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              updates
            })
          })
          .then(response => {
            return response.json();
          })
          .then(response => {
            if (response.status == 422) {
              alert(response.message);
            } else {
              location.reload();
            }
          })
          .catch((error) => {
            response(error);
          });
        }
      }
    })
  });

  document.querySelectorAll('[data-delete-set]').forEach(btn => {
    btn.addEventListener('click', e => {
      if (confirm(btn.dataset.deleteSet)) {
        const id_el = e.target.closest('[data-item-key]');
        const set_id = id_el.dataset.setParentId;
        const items_to_be_removed = [id_el.dataset.itemKey];
        document.querySelectorAll(`[data-set-id="${set_id}"]`).forEach(el=>{
          items_to_be_removed.push(el.dataset.itemKey);
        });
        if (id_el) {
          let updates = {};
          items_to_be_removed.forEach(item=>{
            updates[item] = 0;
          });
          fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              updates
            })
          })
          .then(response => {
            return response.json();
          })
          .then(response => {
            if (response.status == 422) {
              alert(response.message);
            } else {
              location.reload();
            }
          })
          .catch((error) => {
            response(error);
          });
        }
      } 
    })
  });

  const mob_select_all = document.querySelector('[data-mob] [data-all-item-checkbox]'),
  desk_select_all = document.querySelector('[data-desk] [data-all-item-checkbox]'),
  mob_item_checkboxes = document.querySelectorAll('[data-mob] [data-item-checkbox]'),
  desk_item_checkboxes = document.querySelectorAll('[data-desk] [data-item-checkbox]');
  mob_item_checkboxes.forEach(box => {
    box.addEventListener('change', e => {
      let all_checked = true;
      mob_item_checkboxes.forEach(box2 => {
        if (!box2.checked) {
          all_checked = false
        }
      });
      all_checked ? mob_select_all.checked = true : mob_select_all.checked = false;
      update_total_price();
    });
  });

  desk_item_checkboxes.forEach(box => {
    box.addEventListener('change', e => {
      desk_select_all.checked = true;
      let all_checked = true;
      desk_item_checkboxes.forEach(box2 => {
        if (!box2.checked) {
          all_checked = false
        }
      });
      all_checked ? desk_select_all.checked = true : desk_select_all.checked = false;
      update_total_price();
    })
  })

  mob_select_all?.addEventListener('change', e => {
    mob_item_checkboxes.forEach(box => {
      box.checked = mob_select_all.checked;
    });
    update_total_price();
  })

  desk_select_all?.addEventListener('change', e => {
    desk_item_checkboxes.forEach(box => {
      box.checked = desk_select_all.checked;
    })
    update_total_price();
  })

  document.querySelectorAll('[data-change-option]').forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      const item_container = e.target.closest('[data-item-key]')
      if (window.innerWidth < 768) {
        item_container.querySelector('[data-init-variant]').open();
      } else {
        window.open(`/cart?view=change_options&item_key=${item_container.dataset.itemKey}&prod_id=${item_container.dataset.prodId}${item_container.dataset.setId? '&set_id=' + item_container.dataset.setId : ''}`, '_blank', 'height=484,width=471');
      }
    })
  })

  document.querySelector('[data-order-selected]')?.addEventListener('click', e => {
    e.preventDefault();
    let item_checkboxes,item_checkboxes_size;
    item_checkboxes = Array.from(window.innerWidth < 768 ?
      document.querySelectorAll('[data-mob] [data-item-checkbox]') :
      document.querySelectorAll('[data-desk] [data-item-checkbox]'));
    item_checkboxes_size = item_checkboxes.length;
    item_checkboxes = item_checkboxes.filter(x => !x.checked).filter(x => !x.checked);
    if (item_checkboxes.length && item_checkboxes_size != item_checkboxes.length) {
      const set_ids = [];
      const item_keys = item_checkboxes.map(checkbox => {
        const item_container = checkbox.closest('[data-item-key]');
        if (item_container?.hasAttribute('data-set-parent-id')) {
          set_ids.push(item_container.dataset.setParentId);
        }
        return item_container?.dataset.itemKey;
      });
      let updates = {};
      item_keys.forEach(key => {
        updates[key] = 0;
      });
      if (set_ids.length) {
        set_ids.forEach(id=>{
          new Set(Array.from(document.querySelectorAll(`[data-set-id="${id}"]`)).map(el=>el.dataset.itemKey)).forEach(key=>{
            updates[key] = 0
          });
        })
      }
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          updates
        })
      })
      .then(() => {
        window.location.href = "/checkout";
      })
      .catch((error) => {
        alert('Error during checkout!')
      });
    } else if(item_checkboxes_size == item_checkboxes.length){
      alert(e.currentTarget.dataset.orderSelected);
    } else {
      window.location.href = "/checkout";
    }
  })

  document.querySelectorAll('[data-empty-cart]').forEach(btn=>{
    btn.addEventListener('click',e=>{
      e.preventDefault();
      if(confirm(e.currentTarget.dataset.emptyCart)) {
        window.location.href = btn.getAttribute('href');
      }
    })
  });

  function replaceNumberInString(originalString, newNumber) {
    return originalString.replace(/[\d,]+(\.\d+)?/, newNumber);
  }
  
  function update_total_price() {
    let checkboxes = Array.from(window.innerWidth < 768 ?
      document.querySelectorAll('[data-mob] [data-item-checkbox]') :
      document.querySelectorAll('[data-desk] [data-item-checkbox]')).filter(x => x.checked);
    let total_price = 0;
    checkboxes.forEach(box=>{
      total_price += parseInt(box.dataset.itemCheckbox);
    });
    document.querySelectorAll('[data-total-prd-price]').forEach(el=>{
      el.innerHTML = replaceNumberInString(document.querySelector('[data-total-prd-price]').innerHTML, total_price.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
    });
    document.querySelectorAll('[data-total-order-price]').forEach(el=>{
      el.innerHTML = replaceNumberInString(document.querySelector('[data-total-order-price]').innerHTML, total_price.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
    });
  };
})();